import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { ControlButton } from '../../../internal/components/ControlButton';
/**
 * Компонент чекбокса похожего на прозрачную кнопку
 *
 * @export
 * @param {ICheckboxButtonProps} props
 * @returns
 */
export var CheckboxButton = /*#__PURE__*/React.forwardRef(function CheckboxButton(props, ref) {
  return /*#__PURE__*/React.createElement(ControlButton, _extends({}, props, {
    ref: ref,
    type: "checkbox"
  }));
});